/** @format */

import { createAction, props } from '@ngrx/store';

import { AttributeOption } from '../interfaces/attributes-v2.interface';

export const selectedAttributeAction = createAction(
	'[Attribute] Selected',
	props<{ attributeSelected: AttributeOption }>()
);

export const setAllAttributeOptions = createAction(
	'[Attribute] Set All Attribute Options',
	props<{ attributeOptions: AttributeOption[][] }>()
);

export const setAllSelectedAttributeOptions = createAction(
	'[Attribute] Set All Selected Attribute Options',
	props<{ allSelectedAttributeOptions: AttributeOption[] }>()
);

export const setErrorAttribute = createAction(
	'[Attribute] Set Error Attribute',
	props<{ error: { [key: string]: string } }>()
);
